import { SoccerPlayground, SoccerPlaygroundConfig } from "./Objects";
import { Vector2, InputManager, UpdateContext } from "./Engine";

export class App {

    private readonly canvas: HTMLCanvasElement;
    private readonly context: CanvasRenderingContext2D;

    private config: SoccerPlaygroundConfig = new SoccerPlaygroundConfig(new Vector2(20,50), 1000);
    private soccerPlayground? : SoccerPlayground;

    private width: number = 0;
    private height: number = 0;
    private secondsPassed: number = 0;
    private oldTimeStamp: number = 0;

    private showLineToPostsCheckBox: HTMLInputElement;
    private showAngleOfBisectorLineCheckBox: HTMLInputElement;
    private pitchSizeSlider: HTMLInputElement;
    private speedSlider: HTMLInputElement;
    private speedValueLabel: HTMLElement;
    private buttonReset: HTMLButtonElement;

    constructor() {

        this.canvas = document.getElementById('canvas') as HTMLCanvasElement;
        this.context = this.canvas.getContext('2d') as CanvasRenderingContext2D;

        this.showLineToPostsCheckBox = document.getElementById('showLineToPosts') as HTMLInputElement;
        this.showAngleOfBisectorLineCheckBox = document.getElementById('showAngleOfBisectorLine') as HTMLInputElement;
        this.pitchSizeSlider = document.getElementById('pitchSize') as HTMLInputElement;
        this.speedSlider = document.getElementById('speed') as HTMLInputElement;
    this.speedValueLabel = document.getElementById('speedValue') as HTMLElement;
        this.buttonReset = document.getElementById('buttonReset') as HTMLButtonElement;

        this.initialize();
    }

    private initialize() {

        this.resizeCanvas();
        this.context.save();

        InputManager.Initialize(this.canvas);
        this.config.footballSpeed = parseInt(this.speedSlider.value);
        this.soccerPlayground = new SoccerPlayground(this.config);

        window.addEventListener('resize', this.resizeCanvas.bind(this), false);

        this.showLineToPostsCheckBox.addEventListener('change', () => {
            this.config.showLineToPosts = this.showLineToPostsCheckBox.checked;
        });
        
        this.showAngleOfBisectorLineCheckBox.addEventListener('change', () => {
            this.config.showAngleOfBisectorLine = this.showAngleOfBisectorLineCheckBox.checked;
        });
        
        this.pitchSizeSlider.addEventListener('change', () => {
            this.config.width = parseInt(this.pitchSizeSlider.value);
            this.config.recalculate();
            this.resizeCanvas();
            this.soccerPlayground = new SoccerPlayground(this.config);
        });

        this.speedSlider.addEventListener('change', () => {
            this.config.footballSpeed = parseInt(this.speedSlider.value);
        });

        // Update the readonly speed label (km/h) when the slider changes
        this.speedSlider.addEventListener('input', () => {
            const speedValue = parseFloat(this.speedSlider.value) / 10;
            // display as km/h: if footballSpeed is in m/s multiply by 3.6, but here slider already represents km/h
            this.speedValueLabel.textContent = `${speedValue.toFixed(1)} km/h`;
        });

        // Initialize displayed speed value
        const initialSpeed = parseFloat(this.speedSlider.value) / 10;

        this.speedValueLabel.textContent = `${initialSpeed.toFixed(1)} km/h`;



        this.buttonReset.addEventListener('click', () => {
            this.soccerPlayground?.reset();
        });
    }

    public Run() {
        window.requestAnimationFrame(this.gameLoop.bind(this));
    }

    private gameLoop(timeStamp: number) {

        // Calculate the number of seconds passed since the last frame
        this.secondsPassed = (timeStamp - this.oldTimeStamp) / 1000;
        this.oldTimeStamp = timeStamp;

        InputManager.Update();

        this.soccerPlayground?.update(new UpdateContext(timeStamp, this.secondsPassed));
    
        this.context?.clearRect(0, 0, this.width, this.height);
        this.context.fillStyle = 'rgb(0, 128, 0, 0.5)';
        this.context.fillRect(0, 0, this.width, this.height);
        
        this.soccerPlayground?.draw(this.context);
    
        window.requestAnimationFrame(this.gameLoop.bind(this));
    }
    
    private resizeCanvas() {
        this.width = this.canvas.width = this.config.totalWidth;
        this.height = this.canvas.height = this.config.totalHeight;
    }

}